import React from 'react';

import type {IntlShape} from 'react-intl';

import type {ContentShape} from '@edume/magnificent';

import FilePicker from '../FilePicker';

type UploadStepArgs = {
  type: 'image' | 'video';
  intl: IntlShape;
  hintTextKey: string;
  onClose: () => void;
  onFilePick?: (files: File[]) => void;
  isUploading: boolean;
};

const getUploadStep = ({
  type,
  intl,
  hintTextKey,
  onClose,
  isUploading,
  onFilePick = () => {},
}: UploadStepArgs) =>
  ({
    title: intl.formatMessage({id: 'UploadModal.title'}, {type}),
    body: (
      <FilePicker
        type={type}
        onFilePick={onFilePick}
        isUploading={isUploading}
        hintTextKey={hintTextKey}
      />
    ),
    buttons: [
      {
        type: 'secondary',
        onClick: onClose,
        text: intl.formatMessage({id: 'Button.cancel'}),
        dataAutomation: 'cancel-button',
      },
    ],
  }) satisfies ContentShape;

export default getUploadStep;
